import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Sends BFF-authenticated requests (cookie credentials + CSRF header + locale)
 * and redirects to the BFF login on 401.
 */
export const bffInterceptor: HttpInterceptorFn = (req, next) => {
  const authReq = req.clone({
    setHeaders: {
      'x-csrf': '1',
      'Accept-Language': navigator.language || 'en',
    },
    withCredentials: true,
  });

  return next(authReq).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        const returnUrl = encodeURIComponent(
          window.location.pathname + window.location.search + window.location.hash
        );
        window.location.href = `${environment.bffConfig.url}${environment.bffConfig.login}?returnUrl=${returnUrl}`;
      }
      return throwError(() => err);
    })
  );
};
